export const articlesRisk = [
  {
    slug: 'risk-management-basics',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'การบริหารความเสี่ยงก่อนเทรด Forex สิ่งที่มือใหม่ต้องเข้าใจ',
    description:
      'ทำความเข้าใจหลักการบริหารความเสี่ยง Forex ตั้งแต่ Risk per Trade ขนาดสถานะ ไปจนถึงวินัยที่ช่วยให้พอร์ตอยู่รอด',
    readingTime: '9 นาที',
    updatedDate: '2026-09-20',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20risk%20management%20concept%20teal%20shield%20with%20warm%20orange%20percentage%20accents%20on%20light%20clean%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-risk-basics-01&orientation=landscape',
    tags: ['บริหารความเสี่ยง', 'วินัย', 'พื้นฐาน'],
    intro: [
      'เทรดเดอร์ที่อยู่รอดในระยะยาวไม่ได้เก่งที่สุดในการคาดการณ์ทิศทาง แต่เก่งที่สุดในการควบคุมความเสี่ยงที่รับไว้ในแต่ละออเดอร์',
      'บทความนี้จะสรุปหลักการบริหารความเสี่ยงที่มือใหม่ควรยึดถือ',
    ],
    sections: [
      {
        id: 'risk-per-trade',
        heading: 'กำหนดความเสี่ยงต่อออเดอร์',
        paragraphs: [
          'กำหนดความเสี่ยงคงที่ต่อออเดอร์เป็นเปอร์เซ็นต์ของพอร์ต เช่น 1% เพื่อให้รองรับออเดอร์ที่ขาดทุนติดกันโดยไม่ทำลายพอร์ต',
        ],
        bullets: [
          'ความเสี่ยงคงที่ทุกออเดอร์',
          'ไม่เพิ่มความเสี่ยงเพราะอยากเอาคืน',
          'คำนวณขนาดล็อตจากความเสี่ยง ไม่ใช่จากความมั่นใจ',
        ],
        steps: [],
      },
      {
        id: 'plan-first',
        heading: 'วางแผนก่อนเปิดออเดอร์เสมอ',
        paragraphs: [
          'ก่อนกดเปิดออเดอร์ควรรู้แล้วว่าจะเข้าที่ราคาไหน ขาดทุนสูงสุดเท่าไหร่ และทำกำไรที่จุดไหน ถ้าตอบไม่ได้แปลว่ายังไม่พร้อม',
        ],
        bullets: [
          'มีจุดเข้า จุดตัดขาดทุน และจุดทำกำไรชัดเจน',
          'กำหนดอัตราส่วน Risk Reward ล่วงหน้า',
          'บันทึกเหตุผลในการเทรด',
        ],
        steps: [],
      },
      {
        id: 'psychology',
        heading: 'วินัยและการควบคุมอารมณ์',
        paragraphs: [
          'ความกลัวและความโลภเป็นศัตรูตัวจริงของการเทรด การมีกฎที่ชัดเจนและทำตามอย่างสม่ำเสมอช่วยลดการตัดสินใจจากอารมณ์',
          'กฎที่ใช้ได้จริงคือกำหนดจำนวนไม้สูงสุดต่อวันไว้ล่วงหน้า เช่น 3 ไม้ และกำหนดเพดานขาดทุนรายวัน 2% ของพอร์ต ถ้าพอร์ต 5,000 ดอลลาร์ ขาดทุนครบ 100 ดอลลาร์ให้ปิดจอทันที งานวิจัยด้านพฤติกรรมพบว่าเทรดเดอร์ที่ขาดทุนมักเปิดไม้ถี่ขึ้น 2 ถึง 3 เท่าในชั่วโมงถัดมา ซึ่งเป็นช่วงที่การตัดสินใจแย่ที่สุด',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ความเสี่ยงต่อออเดอร์ที่เหมาะสมคือเท่าไหร่',
        a: 'มือใหม่มักใช้ 1% ของพอร์ตต่อออเดอร์ เพื่อให้ทนต่อการขาดทุนต่อเนื่องได้โดยพอร์ตไม่เสียหายหนัก',
        a2: 'ถ้าพอร์ต 1,000 ดอลลาร์ ความเสี่ยง 1% คือ 10 ดอลลาร์ต่อไม้ ซึ่งเทรดได้ราว 0.05 lot บน EUR/USD ที่ Stop Loss 20 Pip และยังคุมอารมณ์ได้',
      },
      {
        q: 'ขาดทุนติดกันหลายออเดอร์ควรทำอย่างไร',
        a: 'ควรหยุดพัก ทบทวนแผน และลดขนาดออเดอร์ลง ไม่ควรพยายามเอาคืนด้วยการเพิ่มความเสี่ยง',
        a2: 'แผนที่ดีควรเขียนไว้ล่วงหน้าว่าถ้าขาดทุนสะสมถึง 3% ของพอร์ตให้หยุดเทรดทั้งวัน แล้วกลับมาดูบันทึกก่อนเริ่มใหม่',
      },
    ],
    related: ['position-sizing', 'risk-reward-ratio', 'drawdown'],
  },
  {
    slug: 'position-sizing',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'Position Sizing คืออะไร วิธีกำหนดขนาดสถานะที่เหมาะสม',
    description:
      'เรียนรู้ Position Sizing และวิธีกำหนดขนาดสถานะให้ความเสี่ยงต่อออเดอร์คงที่ทุกครั้งที่เทรด',
    readingTime: '8 นาที',
    updatedDate: '2026-09-18',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20position%20sizing%20concept%20teal%20blocks%20of%20varying%20size%20warm%20orange%20balance%20scale%20on%20light%20background%20editorial%20flat%20fintech%20no%20text%20no%20people&width=1200&height=675&seq=art-position-sizing-01&orientation=landscape',
    tags: ['Position Sizing', 'ความเสี่ยง', 'Lot'],
    intro: [
      'Position Sizing คือการกำหนดขนาดสถานะให้สัมพันธ์กับความเสี่ยงที่ยอมรับได้ เป็นหัวใจสำคัญที่ทำให้ผลลัพธ์ระยะยาวมั่นคง',
      'บทความนี้จะอธิบายวิธีคิดและปรับใช้ Position Sizing อย่างง่าย',
    ],
    sections: [
      {
        id: 'why',
        heading: 'ทำไม Position Sizing สำคัญ',
        paragraphs: [
          'ออเดอร์ที่ขนาดต่างกันย่อมกระทบพอร์ตไม่เท่ากัน การตรึงความเสี่ยงให้คงที่ช่วยให้ขาดทุนกี่ครั้งก็ยังควบคุมได้',
        ],
        bullets: [
          'ขนาดสถานะต้องมาจากความเสี่ยง ไม่ใช่ความมั่นใจ',
          'Stop Loss ที่กว้างขึ้นต้องใช้ล็อตที่เล็กลง',
          'ความเสี่ยงคงที่ทำให้ผลลัพธ์คาดเดาได้',
        ],
        steps: [],
      },
      {
        id: 'formula',
        heading: 'สูตรคิดแบบง่าย',
        paragraphs: [
          'นำความเสี่ยงเป็นเงินหารด้วยผลคูณของจำนวน Pip ของ Stop Loss กับมูลค่า Pip ต่อล็อต จะได้ขนาดล็อตที่ควรใช้',
        ],
        bullets: [
          'ความเสี่ยงเป็นเงิน = พอร์ต × เปอร์เซ็นต์ความเสี่ยง',
          'ขนาดล็อต = ความเสี่ยงเป็นเงิน ÷ (Pip ของ Stop Loss × มูลค่า Pip ต่อล็อต)',
          'ปรับตามคู่เงินเพราะมูลค่า Pip ต่างกัน',
        ],
        steps: [],
      },
      {
        id: 'adjust',
        heading: 'ปรับอย่างไรเมื่อพอร์ตเปลี่ยน',
        paragraphs: [
          'เมื่อพอร์ตโตขึ้นหรือลดลง ให้คำนวณขนาดล็อตใหม่ทุกครั้ง เพราะความเสี่ยงต้องเป็นเปอร์เซ็นต์ของพอร์ตปัจจุบันเสมอ',
          'ตัวเลขที่ควรจำคือพอร์ต 5,000 ดอลลาร์ เสี่ยง 1% คือ 50 ดอลลาร์ ถ้าพอร์ตลดลงเหลือ 4,000 ดอลลาร์ ความเสี่ยงต่อไม้ต้องลดเป็น 40 ดอลลาร์ หลายคนกลับเลื่อนขนาดขึ้นเพื่อเร่งเอาคืน ทำให้ความเสี่ยงจริงกลายเป็น 2 ถึง 3% โดยไม่รู้ตัว และถ้าขาดติดกัน 5 ไม้ พอร์ตจะหายไปเกือบ 20% แทนที่จะเป็น 5%',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ใช้ล็อตเท่ากันทุกออเดอร์ได้ไหม',
        a: 'ทำได้ แต่จะไม่คงที่ด้านความเสี่ยง เพราะระยะ Stop Loss ต่างกันในแต่ละออเดอร์',
        a2: 'ถ้าไม้ A ใช้ Stop Loss 20 Pip และไม้ B ใช้ 50 Pip การเปิด 0.10 lot เท่ากันจะทำให้ไม้ B เสี่ยง 2.5 เท่าของไม้ A ควรคำนวณ Lot ใหม่ทุกครั้งตามระยะ Stop Loss',
      },
      {
        q: 'ต้องคำนวณเองทุกครั้งไหม',
        a: 'สามารถใช้เครื่องคำนวณ Position Size ช่วยได้ แต่ควรเข้าใจหลักการเพื่อไม่ให้หลงทาง',
        a2: 'กรอก Balance, ความเสี่ยงเป็นเปอร์เซ็นต์ และระยะ Stop Loss เป็น Pip แล้วเครื่องจะบอก Lot ที่ควรใช้ ซึ่งช่วยลดความผิดพลาดจากการคำนวณมือได้มาก',
      },
    ],
    related: ['how-to-calculate-lot', 'risk-management-basics', 'risk-reward-ratio'],
  },
  {
    slug: 'risk-reward-ratio',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'Risk Reward Ratio คืออะไร ทำไมต้องรู้ก่อนเปิดออเดอร์',
    description:
      'เข้าใจ Risk Reward Ratio และวิธีใช้เพื่อให้ผลลัพธ์ระยะยาวเป็นบวกแม้ชนะไม่ถึงครึ่งของออเดอร์',
    readingTime: '7 นาที',
    updatedDate: '2026-09-16',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20risk%20reward%20ratio%20concept%20teal%20short%20bar%20and%20warm%20orange%20long%20bar%20on%20light%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-risk-reward-01&orientation=landscape',
    tags: ['Risk Reward', 'ความเสี่ยง', 'วินัย'],
    intro: [
      'Risk Reward Ratio คือสัดส่วนระหว่างความเสี่ยงกับผลตอบแทนที่คาดหวัง เป็นเครื่องมือที่ช่วยประเมินว่าออเดอร์นั้นคุ้มค่าหรือไม่',
      'บทความนี้จะอธิบายวิธีใช้ Risk Reward ให้เกิดประโยชน์จริง',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'Risk Reward Ratio คืออะไร',
        paragraphs: [
          'ถ้าเราเสี่ยง 25 Pip เพื่อหวังกำไร 50 Pip แสดงว่าอัตราส่วนคือ 1:2 ค่ายิ่งสูงหมายถึงผลตอบแทนต่อความเสี่ยงที่คุ้มค่า',
        ],
        bullets: [
          'Risk คือระยะถึง Stop Loss',
          'Reward คือระยะถึง Take Profit',
          'อัตราส่วนอย่างน้อย 1:2 ช่วยให้ชนะไม่ถึงครึ่งก็ยังกำไร',
        ],
        steps: [],
      },
      {
        id: 'calculate',
        heading: 'คำนวณก่อนเปิดออเดอร์',
        paragraphs: [
          'คำนวณ Risk Reward ก่อนตัดสินใจเปิดออเดอร์ทุกครั้ง ถ้าอัตราส่วนต่ำเกินไปอาจเลือกไม่เทรดออเดอร์นั้น',
        ],
        bullets: [
          'ดูระยะถึง Stop Loss และ Take Profit เป็น Pip',
          'หารระยะ Reward ด้วยระยะ Risk',
          'ปฏิเสธออเดอร์ที่อัตราส่วนไม่คุ้ม',
        ],
        steps: [],
      },
      {
        id: 'discipline',
        heading: 'อย่าฝืนให้ได้อัตราส่วน',
        paragraphs: [
          'อัตราส่วนที่ดีต้องมาจากจุดที่สมเหตุสมผล ไม่ใช่ปรับ Take Profit ให้ไกลเกินจริงจนราคาไปไม่ถึง',
          'เกณฑ์ที่ใช้ตัดสินคือเป้ากำไรต้องอยู่ในระยะที่ราคาเคยไปถึงบ่อยครั้ง ไม่ใช่ตัวเลขที่ทำให้อัตราส่วนสวย เช่น ถ้า EURUSD แกว่งวันละ 70 Pip และคุณตั้ง TP 120 Pip อัตราส่วน 1:6 บนกระดาษดูดี แต่โอกาสถึงเป้าต่ำกว่า 10% และถ้าตั้ง SL 20 Pip กับ TP 20 Pip คุณต้องชนะเกิน 50% หลังจากหัก Spread ถึงจะเสมอตัว',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'อัตราส่วนเท่าไหร่ถึงจะดี',
        a: 'ไม่มีตัวเลขตายตัว แต่มือใหม่มักเริ่มที่ 1:2 ซึ่งช่วยให้ระบบทนทานต่ออัตราการชนะที่ต่ำได้ดี',
        a2: 'ที่ 1:2 คุณต้องชนะเกิน 33.3% จึงจะเท่าทุน ถ้าชนะ 40% ของไม้ ผลลัพธ์สุทธิยังเป็นบวก แต่ไม้ที่แพ้จะแพ้เต็มจำนวนตามที่ตั้งไว้',
      },
      {
        q: 'ถ้าอัตราส่วนดีแต่สัญญาณไม่ชัดควรเทรดไหม',
        a: 'ไม่ควร อัตราส่วนที่ดีต้องมาพร้อมสัญญาณที่สมเหตุสมผลและแผนที่ชัดเจน',
        a2: 'R:R 1:5 ที่มีโอกาสสำเร็จ 10% ให้ค่าคาดหวังติดลบ ขณะที่ 1:1.5 กับโอกาส 50% ให้ค่าคาดหวังเป็นบวก จึงต้องดูทั้งโอกาสและอัตราส่วนพร้อมกัน',
      },
    ],
    related: ['stop-loss-take-profit', 'risk-management-basics', 'position-sizing'],
  },
  {
    slug: 'drawdown',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'Drawdown คืออะไร และวิธีรับมือไม่ให้พอร์ตเสียหายหนัก',
    description:
      'ทำความเข้าใจ Drawdown ระดับการย้อนกลับของพอร์ต และวิธีรับมืออย่างมีสติเพื่อรักษาพอร์ตให้อยู่รอด',
    readingTime: '7 นาที',
    updatedDate: '2026-09-14',
    level: 'ปานกลาง',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20drawdown%20chart%20concept%20teal%20descending%20curve%20with%20warm%20orange%20recovery%20line%20on%20light%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-drawdown-01&orientation=landscape',
    tags: ['Drawdown', 'ความเสี่ยง', 'วินัย'],
    intro: [
      'Drawdown คือการที่พอร์ตย้อนกลับลงจากจุดสูงสุด เป็นสิ่งที่หลีกเลี่ยงไม่ได้ แต่เราสามารถควบคุมระดับของมันได้',
      'บทความนี้จะอธิบายความหมายของ Drawdown และวิธีรับมือเมื่อต้องเจอ',
    ],
    sections: [
      {
        id: 'meaning',
        heading: 'Drawdown คืออะไร',
        paragraphs: [
          'Drawdown คือเปอร์เซ็นต์ที่พอร์ตลดลงจากจุดสูงสุดที่เคยทำได้ ยิ่ง Drawdown ลึก ยิ่งใช้เวลานานในการฟื้นตัวกลับมา',
        ],
        bullets: [
          'Drawdown 10% ต้องทำกำไรประมาณ 11% จึงเท่าทุน',
          'Drawdown 50% ต้องทำกำไรถึง 100% จึงเท่าทุน',
          'ดังนั้นการจำกัด Drawdown จึงสำคัญกว่าการทำกำไรสูง',
        ],
        steps: [],
      },
      {
        id: 'control',
        heading: 'วิธีควบคุม Drawdown',
        paragraphs: [
          'ควบคุมจากขนาดความเสี่ยงต่อออเดอร์และวินัยในการทำตามแผน เมื่อขาดทุนติดกันควรหยุดพักและทบทวน',
        ],
        bullets: [
          'ใช้ความเสี่ยงต่อออเดอร์ต่ำและคงที่',
          'กำหนดเพดานขาดทุนรายวันหรือรายสัปดาห์',
          'หยุดเทรดเมื่อแตะเพดานที่ตั้งไว้',
        ],
        steps: [],
      },
      {
        id: 'recover',
        heading: 'รับมืออย่างไรเมื่อเกิด Drawdown',
        paragraphs: [
          'ทบทวนว่าแผนยังใช้ได้หรือไม่ ลดขนาดออเดอร์ชั่วคราว และกลับมาเทรดเฉพาะเมื่อมีสัญญาณที่ชัดเจน ไม่ใช่เพราะอยากเอาคืน',
          'เกณฑ์ที่ช่วยได้คือถ้าพอร์ตลดลง 10% ให้ลดขนาด Lot ลงครึ่งหนึ่ง และหยุดพักอย่างน้อย 1 สัปดาห์เมื่อแตะ 20% เพราะการชดเชยด้วยคณิตศาสตร์นั้นหนักกว่าที่คิด กล่าวคือ ขาดทุน 20% ต้องทำกำไร 25% จึงจะเท่าทุน ขาดทุน 50% ต้องทำ 100% ซึ่งแทบเป็นไปไม่ได้ภายใต้ความเสี่ยงต่อไม้ที่เท่าเดิม',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Drawdown เท่าไหร่ที่รับได้',
        a: 'ขึ้นอยู่กับแต่ละคน แต่ควรจำกัดไม่ให้ลึกจนกระทบความมั่นใจและความสามารถในการฟื้นตัว เช่นไม่เกิน 20% ของพอร์ต',
        a2: 'ขาดทุน 20% ต้องทำกำไรคืน 25% จึงจะเท่าทุน ขาดทุน 40% ต้องทำคืน 67% นี่คือเหตุผลที่หลายคนตั้งเพดาน Drawdown ไว้ที่ 20%',
      },
      {
        q: 'Drawdown ต่างจากขาดทุนอย่างไร',
        a: 'ขาดทุนคือผลของออเดอร์เดียว ส่วน Drawdown คือผลรวมของการลดลงของพอร์ตจากจุดสูงสุด',
        a2: 'พอร์ตโตไปถึง 5,000 ดอลลาร์แล้วลดลงมาเหลือ 4,200 ดอลลาร์ คือ Drawdown 16% แม้จะยังมีกำไรเมื่อเทียบกับเงินต้น 3,000 ดอลลาร์ก็ตาม',
      },
    ],
    related: ['risk-management-basics', 'position-sizing', 'risk-reward-ratio'],
  },
  {
    slug: 'stop-loss-take-profit',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'วิธีตั้ง Stop Loss และ Take Profit อย่างมีหลักการ',
    description:
      'เรียนรู้วิธีวาง Stop Loss และ Take Profit จากโครงสร้างราคาและอัตราส่วน Risk Reward ที่เหมาะสม',
    readingTime: '8 นาที',
    updatedDate: '2026-09-17',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20stop%20loss%20and%20take%20profit%20concept%20teal%20down%20line%20warm%20orange%20up%20line%20on%20light%20background%20editorial%20flat%20fintech%20no%20text%20no%20people&width=1200&height=675&seq=art-stop-loss-tp-01&orientation=landscape',
    tags: ['Stop Loss', 'Take Profit', 'ความเสี่ยง'],
    intro: [
      'Stop Loss และ Take Profit คือสองเครื่องมือที่เปลี่ยนการเทรดจากเรื่องของอารมณ์ให้กลายเป็นแผนที่มีตัวเลขชัดเจน',
      'บทความนี้จะสอนวิธีวางจุดทั้งสองอย่างให้สอดคล้องกับโครงสร้างราคาและความเสี่ยงที่รับได้',
    ],
    sections: [
      {
        id: 'why',
        heading: 'ทำไมต้องตั้ง Stop Loss และ Take Profit',
        paragraphs: [
          'Stop Loss จำกัดความเสียหายสูงสุดของแต่ละออเดอร์ ส่วน Take Profit ช่วยล็อกกำไรตามแผนโดยไม่ต้องตัดสินใจด้วยความโลภ',
          'ตัวอย่างที่เห็นผลชัดคือพอร์ต 1,000 ดอลลาร์ เปิด 0.10 Lot EURUSD พร้อม Stop Loss 20 Pip ความเสียหายสูงสุดคือ 20 ดอลลาร์ หรือ 2% ของพอร์ต แต่ถ้าไม่มี Stop Loss แล้วราคาวิ่งสวน 150 Pip ในคืนเดียว ขาดทุนจะกลายเป็น 150 ดอลลาร์ หรือ 15% และอาจถึงขั้น Margin Call ก่อนที่คุณจะตื่นมาดูจอ',
        ],
        bullets: [],
        steps: [],
      },
      {
        id: 'how-to-set',
        heading: 'วิธีวางจุด Stop Loss และ Take Profit',
        paragraphs: [
          'วาง Stop Loss ไว้หลังแนวรับหรือแนวต้านที่สำคัญ ไม่ใช่ระยะห่างเท่ากันทุกออเดอร์ และวาง Take Profit ให้สอดคล้องกับอัตราส่วน Risk Reward',
        ],
        bullets: [
          'Stop Loss ควรอยู่หลังจุดที่โครงสร้างราคาจะบอกว่าเราเข้าใจผิด',
          'ไม่ตั้ง Stop Loss ชิดเกินไปจนถูกตัดด้วยความผันผวนปกติ',
          'Take Profit ควรอ้างอิงแนวต้านแนวรับถัดไป',
          'กำหนดอัตราส่วน Risk Reward อย่างน้อย 1:2',
        ],
        steps: [],
      },
      {
        id: 'mistakes',
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'การเลื่อน Stop Loss ให้ห่างออกไปเมื่อราคาสวนทาง เป็นสาเหตุอันดับต้น ๆ ที่ทำให้ขาดทุนลุกลามและควบคุมไม่ได้',
        ],
        bullets: [
          'ไม่ตั้ง Stop Loss แล้วปล่อยออเดอร์ลอยตัว',
          'เลื่อน Stop Loss หนีความจริง',
          'ตั้ง Take Profit ไกลเกินจริงจนราคาไปไม่ถึง',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Risk Reward เท่าไหร่จึงเหมาะสม',
        a: 'มือใหม่มักเริ่มที่ 1:2 คือยอมเสี่ยง 1 เพื่อโอกาสทำกำไร 2 เท่า เพื่อให้แม้ชนะไม่ถึงครึ่งก็ยังมีกำไร',
        a2: 'หลักที่ใช้ได้จริงคือต้องตั้งเป้าจากโครงสร้างราคา ไม่ใช่จากตัวเลขที่อยากได้ ถ้าเป้าหมายไกลเกินโครงสร้างจริงจนชนะน้อยลง ค่าคาดหวังจะลดลงทันที',
      },
      {
        q: 'ตั้ง Stop Loss แบบ Trailing ได้ไหม',
        a: 'ได้ แต่ควรเข้าใจหลักการก่อน ไม่ควรตั้งถี่เกินไปจนถูกตัดออกจากความผันผวนปกติ',
        a2: 'Trailing ที่แคบเกินไป เช่น 10-15 Pip ในตลาดที่แกว่งแรงมักถูกตัดก่อนราคาไปต่อ ควรอิงจาก ATR หรือจุด Swing ล่าสุดจะเสถียรกว่า',
      },
    ],
    related: ['risk-reward-ratio', 'risk-management-basics', 'how-to-calculate-lot'],
  },
  {
    slug: 'how-to-calculate-lot',
    category: 'การบริหารความเสี่ยง',
    categorySlug: 'risk-management',
    title: 'วิธีคำนวณ Lot และขนาดการเทรดให้พอดีกับความเสี่ยง',
    description:
      'สอนวิธีคำนวณขนาดล็อตจากความเสี่ยงต่อออเดอร์และระยะ Stop Loss เพื่อไม่ให้เสี่ยงเกินที่ตั้งใจไว้',
    readingTime: '8 นาที',
    updatedDate: '2026-09-15',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20position%20size%20calculator%20concept%20teal%20bars%20with%20warm%20orange%20percentage%20on%20light%20background%20editorial%20flat%20fintech%20design%20no%20text%20no%20people&width=1200&height=675&seq=art-calc-lot-01&orientation=landscape',
    tags: ['Lot', 'Position Size', 'ความเสี่ยง'],
    intro: [
      'ขนาดการเทรดคือตัวแปรที่เทรดเดอร์ควบคุมได้จริง และเป็นตัวกำหนดว่าออเดอร์นั้นจะกระทบพอร์ตมากแค่ไหน',
      'บทความนี้จะสอนวิธีคำนวณ Lot จากความเสี่ยงและระยะ Stop Loss อย่างง่าย',
    ],
    sections: [
      {
        id: 'principle',
        heading: 'หลักการกำหนดขนาดสถานะ',
        paragraphs: [
          'กำหนดจำนวนเงินที่ยอมเสียต่อออเดอร์เป็นเปอร์เซ็นต์ของพอร์ตก่อน แล้วจึงคำนวณขนาดล็อตให้สอดคล้องกับระยะ Stop Loss',
        ],
        bullets: [
          'กำหนดความเสี่ยงต่อออเดอร์ เช่น 1% ของพอร์ต',
          'คำนวณจำนวน Pip ของ Stop Loss',
          'แปลงเป็นขนาดล็อตที่ทำให้ความเสี่ยงตรงกับที่กำหนด',
        ],
        steps: [],
      },
      {
        id: 'example',
        heading: 'ตัวอย่างการคำนวณ',
        paragraphs: [
          'สมมติพอร์ต 10,000 บาท ความเสี่ยง 1% คือ 100 บาท หาก Stop Loss ห่าง 25 Pips และ 1 Pip ต่อ 0.01 ล็อตมีค่า 0.1 บาท จะคำนวณขนาดล็อตให้ขาดทุนไม่เกิน 100 บาทได้',
        ],
        bullets: [
          'ความเสี่ยงที่ยอมรับ = พอร์ต × เปอร์เซ็นต์ความเสี่ยง',
          'จำนวนเงินต่อ Pip = ความเสี่ยง ÷ จำนวน Pip ของ Stop Loss',
          'ขนาดล็อต = จำนวนเงินต่อ Pip ÷ มูลค่า Pip ต่อล็อต',
        ],
        steps: [],
      },
      {
        id: 'discipline',
        heading: 'วินัยสำคัญกว่าสูตร',
        paragraphs: [
          'แม้สูตรคำนวณจะถูกต้อง แต่ถ้าขยายขนาดออเดอร์เมื่ออารมณ์อยากได้กำไรมากขึ้น ความเสี่ยงก็จะหลุดกรอบทันที ให้ยึดความเสี่ยงคงที่ทุกออเดอร์',
          'ยกตัวอย่างพอร์ต 3,000 ดอลลาร์ เสี่ยง 1% คือ 30 ดอลลาร์ต่อไม้ ถ้าเปลี่ยนไปเสี่ยง 3% เพราะมั่นใจเป็นพิเศษ เท่ากับ 90 ดอลลาร์ต่อไม้ และถ้าขาดติดกัน 4 ไม้ พอร์ตจะหายไป 360 ดอลลาร์ หรือ 12% ซึ่งต้องทำกำไร 13.6% เพื่อกลับมาเท่าทุน ความมั่นใจไม่ได้เปลี่ยนความน่าจะเป็นของตลาด มีแต่เปลี่ยนขนาดความเสียหาย',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Standard Lot เท่ากับเท่าไหร่',
        a: 'Standard Lot คือ 1.00 ล็อต โดย 0.10 คือ Mini Lot และ 0.01 คือ Micro Lot',
        a2: '1.00 lot คือ 100,000 หน่วย, 0.10 lot คือ 10,000 หน่วย, 0.01 lot คือ 1,000 หน่วย บน EUR/USD มูลค่าต่อ Pip คือ 10, 1 และ 0.10 ดอลลาร์ตามลำดับ',
      },
      {
        q: 'ความเสี่ยงต่อออเดอร์ควรเป็นกี่เปอร์เซ็นต์',
        a: 'มือใหม่มักใช้ 1% ของพอร์ตต่อออเดอร์ เพื่อให้รองรับออเดอร์ที่ขาดทุนติดกันได้หลายครั้ง',
        a2: 'ถ้าเสี่ยง 1% ต่อไม้และแพ้ติด 10 ไม้ พอร์ตจะหายราว 9.6% แต่ถ้าเสี่ยง 3% ต่อไม้ ตัวเลขจะพุ่งเป็นราว 26% ในสถานการณ์เดียวกัน',
      },
    ],
    related: ['position-sizing', 'risk-management-basics', 'stop-loss-take-profit'],
  },
];